<!-- Nurse Salary Rates - Before 1 Year -->
<p class="font-semibold text-2xl text-black mb-5">
    Nurse Salary Rates - Before 1 Year
  </p>
  <div class="flex">
    <form [formGroup]="beforeSalaryForm" (ngSubmit)="onUpdateBefore()">
      <div class="w-full xl:w-1/3 2xl:w-full">
        <table tuiTable size="m" class="md:w-full lg:w-[37rem] xl:w-[50rem] 2xl:w-[70rem]">
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">Shift</th>
              <th tuiTh style="background-color: #285ca5; color: white">Type</th>
              <th tuiTh style="background-color: #285ca5; color: white">With Meal</th>
              <th tuiTh style="background-color: #285ca5; color: white">Without Meal</th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr>
              <td tuiTd rowspan="3">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">12 hr</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Normal</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel >
                    <tui-input style="width: 100px;" formControlName="beforeYear12hrNormalWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="beforeYear12hrNormalWithoutMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Babycare</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="beforeYear12hrBabycareWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="beforeYear12hrBabycareWithoutMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">NHP (National hospital)</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="beforeYear12hrNHPWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="beforeYear12hrNHPWithoutMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd rowspan="3">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">24 hr</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Normal</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="beforeYear24hrNormalWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">N/A</p>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Babycare</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="beforeYear24hrBabycareWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">N/A</p>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">NHP (National hospital)</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="beforeYear24hrNHPWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">N/A</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt-5 space-x-5 flex justify-end">
        <button 
        appearance="primary" 
        tuiButton 
        type="submit" 
        class="w-[180px]" 
        [disabled]="isSalaryBeforeSaving"
        [appDisableUnlessPermission]="'SALARY_CHARGES_UPDATE'"
      >
        <ng-container *ngIf="!isSalaryBeforeSaving">Update Salary</ng-container>
        <ng-container *ngIf="isSalaryBeforeSaving">Updating...</ng-container>
      </button>
      </div>
    </form>
  </div>
  
  <!-- Nurse Salary Rates - After 1 Year -->
  <p class="font-semibold text-2xl text-black my-5">
    Nurse Salary Rates - After 1 Year
  </p>
  <div class="flex">
    <form [formGroup]="afterSalaryForm" (ngSubmit)="onUpdateAfter()">
      <div class="w-full xl:w-1/3 2xl:w-full">
        <table tuiTable size="m" class="md:w-full lg:w-[37rem] xl:w-[50rem] 2xl:w-[70rem]">
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">Shift</th>
              <th tuiTh style="background-color: #285ca5; color: white">Type</th>
              <th tuiTh style="background-color: #285ca5; color: white">With Meal</th>
              <th tuiTh style="background-color: #285ca5; color: white">Without Meal</th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr>
              <td tuiTd rowspan="3">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">12 hr</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Normal</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="afterYear12hrNormalWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="afterYear12hrNormalWithoutMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Babycare</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="afterYear12hrBabycareWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="afterYear12hrBabycareWithoutMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">NHP (National hospital)</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="afterYear12hrNHPWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="afterYear12hrNHPWithoutMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd rowspan="3">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">24 hr</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Normal</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="afterYear24hrNormalWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">N/A</p>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Babycare</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="afterYear24hrBabycareWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">N/A</p>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">NHP (National hospital)</p>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="afterYear24hrNHPWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd>
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">N/A</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt-5 space-x-5 flex justify-end">
        <button 
        appearance="primary" 
        tuiButton 
        type="submit" 
        class="w-[180px]" 
        [disabled]="isSalaryAfterSaving"
        [appDisableUnlessPermission]="'SALARY_CHARGES_UPDATE'"
      >
        <ng-container *ngIf="!isSalaryAfterSaving">Update Salary</ng-container>
        <ng-container *ngIf="isSalaryAfterSaving">Updating...</ng-container>
      </button>
      </div>
    </form>
  </div>
  

  <p class="font-semibold text-2xl text-black my-5">
    Client Charges
  </p>
  <div class="flex">
    <form [formGroup]="chargeForm" (ngSubmit)="onUpdateCharge()">
      <div class="w-full xl:w-1/3 2xl:w-full">
        <table tuiTable size="m" class="md:w-full lg:w-[37rem] xl:w-[50rem] 2xl:w-[70rem]">
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">Shift</th>
              <th tuiTh style="background-color: #285ca5; color: white">Type</th>
              <th tuiTh style="background-color: #285ca5; color: white">With Meal</th>
              <th tuiTh style="background-color: #285ca5; color: white">Without Meal</th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <!-- 12 hr Shift -->
            <tr>
              <td tuiTd rowspan="3" style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">12 hr</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Normal</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="twelveHourNormalWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="twelveHourNormalWithoutMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Babycare</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="twelveHourBabycareWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="twelveHourBabycareWithoutMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">NHP (National hospital)</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="twelveHourNHPWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="twelveHourNHPWithoutMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
            </tr>
            <!-- 24 hr Shift -->
            <tr>
              <td tuiTd rowspan="3" style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">24 hr</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Normal</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="twentyFourHourNormalWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">N/A</p>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">Babycare</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="twentyFourHourBabycareWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">N/A</p>
                </div>
              </td>
            </tr>
            <tr>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">NHP (National hospital)</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <label tuiLabel>
                    <tui-input style="width: 100px;" formControlName="twentyFourHourNHPWithMeal">
                      <input tuiTextfieldLegacy type="number" />
                    </tui-input>
                  </label>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">N/A</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt-5 space-x-5 flex justify-end">
        <button 
        appearance="primary" 
        tuiButton 
        type="submit" 
        class="w-[180px]" 
        [disabled]="isChargesSaving"
        [appDisableUnlessPermission]="'SALARY_CHARGES_UPDATE'"
      >
        <ng-container *ngIf="!isChargesSaving">Update Charges</ng-container>
        <ng-container *ngIf="isChargesSaving">Updating...</ng-container>
      </button>
      </div>
    </form>
  </div>

<!-- Fee Management Section -->
<p class="font-semibold text-2xl text-black mb-5 mt-10">
  Fee Management
</p>
<div class="flex">
  <form [formGroup]="feeForm" (ngSubmit)="submitFeeUpdate()">
    <div class="w-full xl:w-1/3 2xl:w-full">
      <table tuiTable size="m" class="md:w-full lg:w-[37rem] xl:w-[50rem] 2xl:w-[70rem]">
        <thead>
          <tr>
            <th tuiTh style="background-color: #285ca5; color: white">Fee Type</th>
            <th tuiTh style="background-color: #285ca5; color: white">Amount (LKR)</th>
          </tr>
        </thead>
        <tbody tuiTbody>
          <tr>
            <td tuiTd>
              <div tuiCell="m">
                <p class="text-[#191C30E5] text-sm font-medium">Registration Fee (One Year)</p>
              </div>
            </td>
            <td tuiTd>
              <div tuiCell="m">
                <label tuiLabel>
                  <tui-input style="width: 150px;" formControlName="registrationFee">
                    <input tuiTextfieldLegacy type="number" />
                  </tui-input>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <td tuiTd>
              <div tuiCell="m">
                <p class="text-[#191C30E5] text-sm font-medium">Renewal Fee (One Year)</p>
              </div>
            </td>
            <td tuiTd>
              <div tuiCell="m">
                <label tuiLabel>
                  <tui-input style="width: 150px;" formControlName="renewalFee">
                    <input tuiTextfieldLegacy type="number" />
                  </tui-input>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <td tuiTd>
              <div tuiCell="m">
                <p class="text-[#191C30E5] text-sm font-medium">Lifetime Registration Fee</p>
              </div>
            </td>
            <td tuiTd>
              <div tuiCell="m">
                <label tuiLabel>
                  <tui-input style="width: 150px;" formControlName="lifetimeRegistrationFee">
                    <input tuiTextfieldLegacy type="number" />
                  </tui-input>
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-5 space-x-5 flex justify-end">
      <button 
        appearance="primary" 
        tuiButton 
        type="submit" 
        class="w-[180px]" 
        [disabled]="feeLoading" 
        [appDisableUnlessPermission]="'SALARY_CHARGES_UPDATE'"
      >
        <ng-container *ngIf="!feeLoading">Update Fees</ng-container>
        <ng-container *ngIf="feeLoading">Updating...</ng-container>
      </button>
    </div>
  </form>
</div>
  

